export const API_BASE_URL = '/api';

export const PARTICIPATION_STATUS = {
  claimed: { label: 'Claimed', color: 'bg-blue-100 text-blue-800' },
  submitted: { label: 'Pending Review', color: 'bg-yellow-100 text-yellow-800' },
  approved: { label: 'Approved', color: 'bg-green-100 text-green-800' },
  rejected: { label: 'Rejected', color: 'bg-red-100 text-red-800' },
} as const;

export const TASK_STATUS = {
  draft: { label: 'Draft', color: 'bg-gray-100 text-gray-800' },
  active: { label: 'Active', color: 'bg-green-100 text-green-800' },
  inactive: { label: 'Inactive', color: 'bg-orange-100 text-orange-800' },
  completed: { label: 'Completed', color: 'bg-blue-100 text-blue-800' },
  expired: { label: 'Expired', color: 'bg-red-100 text-red-800' },
} as const;

export const TRANSACTION_TYPE = {
  reward: { label: 'Reward', color: 'text-green-600' },
  payment: { label: 'Payment', color: 'text-red-600' },
  adjustment: { label: 'Adjustment', color: 'text-blue-600' },
} as const;

// Malaysian states and federal territories. Kept in sync with the backend
// list in apps/api/src/config/states.ts (MALAYSIAN_STATES).
export const MALAYSIAN_STATES = [
  'Johor',
  'Kedah',
  'Kelantan',
  'Melaka',
  'Negeri Sembilan',
  'Pahang',
  'Perak',
  'Perlis',
  'Pulau Pinang',
  'Sabah',
  'Sarawak',
  'Selangor',
  'Terengganu',
  'Kuala Lumpur',
  'Labuan',
  'Putrajaya',
] as const;
